/**
 * 用户
 */

import { get, post, put, del } from "@/util/request";
import { sha256 } from "@/util/encryption";
import download from "@/util/download";

/**
 * 根据Id查询
 * @param {*} Id
 * @returns
 */
export const SelectUserById = (Id) => {
  return get("/api/app/User?CurrentId=" + Id);
};

/**
 * 新增数据记录
 * @param {*} data
 * @returns
 */
export const AddUser = (data) => {
  data.password = sha256(data.password);
  return post("/api/app/User", data, {});
};

/**
 * 更新数据记录
 * @param {*} data
 * @returns
 */
export const ModifyUser = (data) => {
  data.password = "";
  return put("/api/app/User", data, {});
};

/**
 * 分页获取
 * @param {*} data
 * @returns
 */
export const GetDataUserList = (data) => {
  return post("/api/app/User/list", data, {});
};

/**
 * 链表分页获取
 * @param {*} data
 * @returns
 */
export const GetDataUserListByPageQuery = (data) => {
  return post("/api/app/user/getDataByPageQuery", data, {});
};

/**
 * 链表分页获取
 * @param {*} data
 * @returns
 */
export const GetCategoryListById = (data) => {
  return post("/api/app/userCaegory/getDataByPageQuery", data, {});
};
/**
 * 删除记录
 * @param {*} id
 * @returns
 */
export const DeleteUser = (id) => {
  return del("/api/app/User/" + id, {}, {});
};

/**
 * 编辑申请状态
 * @param {*} data
 * @returns
 */
export const ModifyStatus = (id, type) => {
  return post(`/api/app/user/upataUserStateById/${id}?state=${type}`);
};

//更新密码
export const UpdataUserPossword = (data) => {
  return put(
    `/api/app/user/pwd?userCode=${data.userCode}&newPwd=${data.newPwd}`,
    {}
  );
};

/**
 * 导出Excel
 * @param {*} id
 * @returns
 */
export const ExportUserInfo = (data, title) => {
  let defaluturl = `/api/app/user/exportExcelFile`;
  let fileName = "用户信息";
  if (title) {
    fileName = title;
  }
  return download(fileName, defaluturl, data);
};

/**
 * 导出一人一档压缩包
 * @param {*} data
 * @returns
 */
export const ExportUserArchiveZip = (data) => {
  const defaluturl = `/api/app/user/exportUserArchiveZip`;
  const now = new Date();
  const pad = (num) => `${num}`.padStart(2, "0");
  const timeText = `${now.getFullYear()}${pad(now.getMonth() + 1)}${pad(
    now.getDate()
  )}_${pad(now.getHours())}${pad(now.getMinutes())}${pad(now.getSeconds())}`;
  const fileName = `一人一档_${timeText}.zip`;
  return download(fileName, defaluturl, data);
};

/**
 * 修改用户课程分类
 * @param {*} data
 * @returns
 */
export const EditUserCategory = (data) => {
  return post("/api/app/userCaegory/userCaegorys", data);
};

/**
 * 分页获取课程分类
 * @param {*} data
 * @returns
 */
 export const GetDataCourseCategoryList = (data) => {
  return post('/api/app/courseCategory/wXGetCourseCategoryList', data, {});
}

/**
 * 获取用户数据权限
 * @param {*} data
 * @returns
 */
export const GetUserDataPermissions = (Id) => {
  return get("/api/app/userDataPermission/userDataPermissions/" + Id);
};

/**
 * 保存用户数据权限
 * @param {*} data
 * @returns
 */
export const SaveUserDataPermissions = (data,userId) => {
  return post(`/api/app/userDataPermission/saveUserDataPermissions/${userId}`, data, {});
}

export const GetUserPosts = () => {
  return get("/api/app/userPost/userPosts");
}
